import React from 'react';
import { LoadingSpinner } from 'yankees-react-utils';
import { useTranslation } from 'react-i18next';
import PitchTabTable from './PitchTabTable';

const ByCountTab = ({ isLoading, pitchTypes, isLhp, isLoadingAvg }) => {
    const { t: translate } = useTranslation();

    if (isLoading) {
        return (
            <div className="py-5 text-center">
                <LoadingSpinner />
            </div>
        );
    }

    const filteredPitchTypes = pitchTypes.filter((pt) => pt.strikes >= 0 && pt.balls >= 0);

    return (
        filteredPitchTypes.length
            ? (
                <div>
                    {Array.from({ length: 4 }, (_, i) => i).map((balls) => Array.from({ length: 3 }, (_, i) => i).map((strikes) => (
                        <div className="mb-4" key={`${balls}-${strikes}`}>
                            <h4>{translate(`sections.reports.pitcher.counts-${balls}-${strikes}`)}</h4>
                            <PitchTabTable
                                pitchTypes={filteredPitchTypes.filter((pt) => pt.balls === balls && pt.strikes === strikes)}
                                isLhp={isLhp}
                                isLoadingAvg={isLoadingAvg}
                            />
                        </div>
                    )))}
                </div>
            )
            : <div className="py-5 text-center">{translate('pitcher-overview.no-data')}</div>
    );
};

export default ByCountTab;
